<script setup lang="ts">
definePageMeta({
  layout: "no-bread-crumbs",
});

useHead({
  title: "中途採用",
  meta: [{ name: "description", content: "ファミリー庭園中途採用フォーム" }],
});

const { recruitData, resetData } = useRecruit();
const { isChange } = useLeaveForms();

if (recruitData.value.form_type != "career") {
  // formtypeが異なる場合リセットをかける
  resetData();
  // formtypeを現在のformtypeに設定
  recruitData.value.form_type = "career";
}

watchOnce(
  () => recruitData.value,
  () => {
    isChange.value = true;
    recruitData.value.recruit_cd = 2;
  },
  { deep: true },
);

function handleSubmit(e: Event) {
  isChange.value = false;
  useRouter().push("/recruit/confirm");
}

const recruitFlow = [
  "会社説明",
  " 面接(複数回)・適正テスト",
  "内定",
  "(入社日相談の上)入社",
];
</script>

<template>
  <RecruitPage title="中途採用">
    <template #content>
      <div class="p-recruit__content">
        <h2 class="p-recruit__h2">ファミリー庭園とは？</h2>
        <p>
          <span class="block"
            >当社は、家の外まわり（外構・お庭など）をデザイン・設計・施工する会社です。</span
          >
          <span class="block"
            >ホームページの施工実績数やお客様の声などを見ていただければ分かるかと思われますが、弊社は日本一の規模を誇る、業界のリーディングカンパニーです。</span
          >
        </p>
        <p class="text-4xl font-serif italic mt-10 mb-4">Leading Company</p>
        <ImageEl
          class="w-full"
          src="/images/recruit/leading-company.png"
          alt="Leading Company"
          width="1900"
          height="950"
          sizes="sm:100vw lg:1000px"
          format="webp"
        />
      </div>

      <div class="p-recruit__content">
        <h2 class="p-recruit__h2">求めている人材</h2>
        <p>求めている人材は「真面目な方」です。</p>

        <p>
          そして、弊社の経営理念である「お客様の利益」に共感し、私たちと一緒に仕事に取り組んでいただける方です。
        </p>
        <p>ノルマや飛び込み営業はありません。</p>
        <p>
          未経験者でも仕事がしやすいよう、業務の多くはシステム化されており、お客様にご満足いただけるノウハウがあります。
        </p>
        <ImageEl
          class="w-full my-5"
          src="/images/recruit/career.png"
          alt="Leading Company"
          width="1021"
          height="680"
          sizes="sm:100vw lg:1000px"
          format="webp"
        />
        <p class="mb-8">
          お客様と直接打合せを行うので（BtoC）、お客様から直接嬉しいお言葉をいただけてやりがいを感じることができます。
        </p>
        <NuxtLink
          to="/e_list"
          class="border border-gray-400 rounded shadow-md m-auto p-3 px-16 bg-gray-100"
          >お客様からの手紙</NuxtLink
        >
      </div>

      <div class="p-recruit__content">
        <h2 class="p-recruit__h2">採用フロー</h2>
        <ListFlowBox :flow="recruitFlow" />
      </div>

      <div class="p-recruit__content">
        <h2 class="p-recruit__h2">会社説明会</h2>
        <p>
          <span class="block"
            >下記のお問い合わせフォームもしくはお電話にて、事前予約をお願いします。</span
          >
          <span class="block">その際に時間などを調整いたします。</span>
          <span class="block"
            >また説明会後、すぐ1次面接させて頂くことも可能ですので、ご希望の方は履歴書をご持参ください。</span
          >
        </p>
        <p class="font-bold text-red-600 mt-5">WEB説明会・面接も随時開催中</p>
      </div>
      <div class="p-recruit__content">
        <div class="p-recruit__content--entry">
          <div class="entry">
            <p>お電話でのご予約はこちらから</p>
            <p class="tel-number">
              <Icon size="24" name="mdi:phone" />
              06-6777-9544
            </p>
            <p>
              ネットでのご予約、お申し込みは下記メールフォームより受け付けております
            </p>
          </div>
        </div>
      </div>
    </template>
    <template #form>
      <FormParent :submit="handleSubmit">
        <RecruitForm type="career"></RecruitForm>
      </FormParent>
    </template>
  </RecruitPage>
</template>
